import { render, staticRenderFns } from "./company-filters.vue?vue&type=template&id=451aff8e&"
import script from "./company-filters.vue?vue&type=script&lang=js&"
export * from "./company-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports